import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import {
  postReservationAccept,
  updateReservationStatus,
  sendTableReadyMessage,
} from "../../actions/restaurantActions";
import {
  fetchCancelReservation,
  checkCancelAction,
} from "../../actions/reservationsActions";
import {
  statusToGroup,
  labelColors,
  iconStatusMap,
  ModernButton,
} from "../DefaultImports";
import CompareChanges from "../CompareChanges";
import StatusDropdown from "../StatusDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  acceptedStatuses,
  pendingStatuses,
  getReservationStatusAbreviationTranslation,
  getReservationStatusColors,
  getReservationStatusTooltipTranslationForRestaurant,
} from "../ReservationStatus";
import Tooltip from "../ToolTipWrapper";
import { CustomModal } from "../CustomModal";

const LineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  background: ${({ color }) =>
    color
      ? `rgba(${parseInt(color.slice(1, 3), 16)}, ${parseInt(
          color.slice(3, 5),
          16,
        )}, ${parseInt(color.slice(5, 7), 16)}, 0.7)`
      : "rgba(255, 255, 255, 0.45)"};
  padding: 0 0 0 5px;
  width: 100%;
  height: 100%;
`;

const IconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ bg }) => bg || "#eee"};
  color: ${({ color }) => color || "#333"};
  width: 50%;
  height: 100%;
  cursor: pointer;
  transition: background 0.2s;
  border-left: 1px solid #fff;
  &:hover {
    background: ${({ hoverBg }) => hoverBg || "#ddd"};
  }
`;

const InBetween = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
`;

function ReservationStatusChanger({ reservation, past_estimated_time }) {
  const dispatch = useDispatch();
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showAttendedModal, setShowAttendedModal] = useState(false);
  const [showNotAttendedModal, setShowNotAttendedModal] = useState(false);
  const [showLeftModal, setShowLeftModal] = useState(false);
  const [rejectEdition, setRejectEdition] = useState(false);
  const [reservationBeforeEdition, setReservationBeforeEdition] =
    useState(null);
  const [notify_customer, setNotify_customer] = useState(true);

  useEffect(() => {
    if (reservation?.history && reservation.restore_version_id !== undefined) {
      const item = reservation.history.find(
        (h) => h.history_id === reservation.restore_version_id,
      );
      setReservationBeforeEdition(item || null);
    } else {
      setReservationBeforeEdition(null);
    }
  }, [reservation]);

  const handleAccept = () => {
    dispatch(
      postReservationAccept(
        reservation.token,
        false,
        rejectEdition,
        notify_customer,
      ),
    );
    setShowAcceptModal(false);
  };

  const handleCancelCheck = () => {
    dispatch(checkCancelAction(reservation.token));
    setShowAcceptModal(false);
  };

  const handleCancel = () => {
    dispatch(
      fetchCancelReservation(reservation.id, false, false, rejectEdition),
    );
    setShowCancelModal(false);
  };

  const handleAttended = () => {
    dispatch(updateReservationStatus(reservation.id, "Attended"));
    setShowAttendedModal(false);
  };

  const handleNotAttended = () => {
    dispatch(updateReservationStatus(reservation.id, "Did_Not_Attend"));
    setShowNotAttendedModal(false);
  };

  const handleLeft = () => {
    dispatch(updateReservationStatus(reservation.id, "Left"));
    setShowLeftModal(false);
  };

  const [sendTableReadyMsg, setSendTableReadyMsg] = useState(true);

  const isWaitingList = reservation?.status === "waiting_list";
  useEffect(() => {
    if (showAttendedModal && isWaitingList) {
      setSendTableReadyMsg(true);
    }
  }, [showAttendedModal, isWaitingList]);

  const sendTheTableReadyMessage = () => {};

  const handleAttendedWithOptionalMessage = () => {
    dispatch(updateReservationStatus(reservation.id, "Attended"));

    if (reservation?.status === "waiting_list" && sendTableReadyMsg) {
      dispatch(sendTableReadyMessage(reservation.token));
    }

    setShowAttendedModal(false);
  };

  return (
    <LineWrapper color={labelColors[statusToGroup[reservation.status]]}>
      <Tooltip
        text={getReservationStatusTooltipTranslationForRestaurant(
          reservation.is_reconfirmation_message_sent
            ? "Awaiting_customer_reconfirmation_after_message"
            : reservation.status,
        )}
      >
        <FontAwesomeIcon
          icon={iconStatusMap[statusToGroup[reservation.status]].icon}
          style={{ color: "#fff", cursor: "pointer", marginRight: "5px" }}
        />
      </Tooltip>

      <InBetween>
        <StatusDropdown
          reservation={reservation}
          allowedStatuses={[
            "Accepted",
            "Pending_from_restaurant",
            "Awaiting_customer_reconfirmation",
            "Late",
            "waiting_list",
            "Attended",
            "Left",
            "Did_Not_Attend",
            "Cancelled_By_Restaurant",
            "Cancelled_By_Customer",
          ]}
          getStatusColor={getReservationStatusColors}
          getStatusLabel={getReservationStatusAbreviationTranslation}
          onSelectStatus={(status) => {
            dispatch(updateReservationStatus(reservation.id, status));
          }}
        />
        <div
          style={{
            height: "100%",
            width: "150px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          {pendingStatuses.includes(reservation.status) && (
            <>
              <IconButton
                bg="#99b0ad"
                color="#fff"
                hoverBg="#bbbbbb"
                onClick={() => {
                  setRejectEdition(false);
                  setShowAcceptModal(true);
                }}
              >
                <FontAwesomeIcon icon={faCheck} />
              </IconButton>
              <IconButton
                bg="#99b0ad"
                color="#fff"
                hoverBg="#bbbbbb"
                onClick={() => {
                  setRejectEdition(false);
                  setShowCancelModal(true);
                }}
              >
                <FontAwesomeIcon icon={faTimes} />
              </IconButton>
            </>
          )}

          {reservation.status === "Edited" && (
            <>
              <IconButton
                bg="#99b0ad"
                color="#fff"
                hoverBg="#bbbbbb"
                onClick={() => {
                  setRejectEdition(true);
                  setShowAcceptModal(true);
                }}
              >
                <Tooltip
                  text={getReservationStatusTooltipTranslationForRestaurant(
                    "Edited_accept",
                  )}
                >
                  <FontAwesomeIcon icon={faCheck} />
                </Tooltip>
              </IconButton>{" "}
              <IconButton
                bg="#99b0ad"
                color="#fff"
                hoverBg="#bbbbbb"
                onClick={() => {
                  setRejectEdition(true);
                  setShowCancelModal(true);
                }}
              >
                <Tooltip
                  text={getReservationStatusTooltipTranslationForRestaurant(
                    "Edited_reject",
                  )}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </Tooltip>
              </IconButton>
            </>
          )}

          {acceptedStatuses.includes(reservation.status) &&
            reservation.status != "Awaiting_customer_reconfirmation" && (
              <>
                <IconButton
                  bg="#99b0ad"
                  color="#fff"
                  hoverBg="#bbbbbb"
                  onClick={() => setShowAttendedModal(true)}
                >
                  <FontAwesomeIcon icon={faCheck} />
                </IconButton>
                <IconButton
                  bg="#99b0ad"
                  color="#fff"
                  hoverBg="#bbbbbb"
                  onClick={() => setShowNotAttendedModal(true)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </IconButton>
              </>
            )}

          {reservation.status === "Attended" && (
            <>
              <IconButton
                bg="#99b0ad"
                color="#fff"
                hoverBg="#bbbbbb"
                onClick={() => setShowLeftModal(true)}
                style={{ width: "100%" }}
              >
                <FontAwesomeIcon icon={faCheck} /> {/* Optional: change icon */}
              </IconButton>
            </>
          )}
          {reservation.cancelled_warning && (
            <>
              <IconButton
                bg="#99b0ad"
                color="#fff"
                hoverBg="#bbbbbb"
                onClick={() => handleCancelCheck()}
                style={{ width: "100%" }}
              >
                <FontAwesomeIcon icon={faEye} />
              </IconButton>
            </>
          )}
        </div>
      </InBetween>

      {/* Accept Modal */}
      <CustomModal
        show={showAcceptModal}
        onHide={() => setShowAcceptModal(false)}
        title="Aceitar reserva"
        body={
          rejectEdition && reservationBeforeEdition ? (
            <CompareChanges
              before={reservationBeforeEdition}
              after={reservation}
            />
          ) : (
            <p>Tens a certeza que pretendes aceitar esta reserva?</p>
          )
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              fontSize="14px"
              onClick={() => setShowAcceptModal(false)}
            >
              Cancelar
            </ModernButton>
            <ModernButton
              color="#EE754C"
              fontSize="14px"
              onClick={handleAccept}
            >
              Aceitar reserva
            </ModernButton>
          </>
        }
      />

      {/* Cancel Modal */}
      <CustomModal
        show={showCancelModal}
        onHide={() => setShowCancelModal(false)}
        title="Rejeitar reserva"
        body={
          rejectEdition && reservationBeforeEdition ? (
            <CompareChanges
              before={reservationBeforeEdition}
              after={reservation}
            />
          ) : (
            <p>Tens a certeza que pretendes rejeitar esta reserva?</p>
          )
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              fontSize="14px"
              onClick={() => setShowCancelModal(false)}
            >
              Cancelar
            </ModernButton>
            <ModernButton
              color="#EE754C"
              fontSize="14px"
              onClick={handleCancel}
            >
              Rejeitar reserva
            </ModernButton>
          </>
        }
      />

      {/* Attended Modal */}
      {/* Attended Modal */}
      <CustomModal
        show={showAttendedModal}
        onHide={() => setShowAttendedModal(false)}
        title="Confirmar presença"
        body={
          <>
            <p>
              Tens a certeza que pretendes alterar o estado da reserva para{" "}
              <strong>Compareceu</strong>?
            </p>

            {isWaitingList && (
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "12px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <input
                  type="checkbox"
                  checked={sendTableReadyMsg}
                  onChange={(e) => setSendTableReadyMsg(e.target.checked)}
                  style={{ accentColor: "#EE754C", textColor: "white" }}
                />
                <span style={{ fontWeight: 700 }}>
                  Enviar mensagem de aviso ao cliente
                </span>
              </label>
            )}
          </>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              fontSize="14px"
              onClick={() => setShowAttendedModal(false)}
            >
              Não confirmar
            </ModernButton>

            <ModernButton
              color="#EE754C"
              fontSize="14px"
              onClick={handleAttendedWithOptionalMessage}
            >
              Confirmar presença
            </ModernButton>
          </>
        }
      />

      {/* Not Attended Modal */}
      <CustomModal
        show={showNotAttendedModal}
        onHide={() => setShowNotAttendedModal(false)}
        title="Confirmar ausência"
        body={
          <p>
            Tens a certeza que pretendes alterar o estado da reserva para{" "}
            <strong>Não compareceu</strong>?
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              fontSize="14px"
              onClick={() => setShowNotAttendedModal(false)}
            >
              Não confirmar
            </ModernButton>
            <ModernButton
              color="#EE754C"
              fontSize="14px"
              onClick={handleNotAttended}
            >
              Confirmar ausência
            </ModernButton>
          </>
        }
      />

      {/* Left Modal */}
      <CustomModal
        show={showLeftModal}
        onHide={() => setShowLeftModal(false)}
        title="Libertar mesa"
        body={<p>Tens a certeza que pretendes libertar esta mesa?</p>}
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              fontSize="14px"
              onClick={() => setShowLeftModal(false)}
            >
              Não
            </ModernButton>
            <ModernButton color="#EE754C" fontSize="14px" onClick={handleLeft}>
              Sim
            </ModernButton>
          </>
        }
      />
    </LineWrapper>
  );
}

export default ReservationStatusChanger;
